import {BackHandler} from "react-native";

BackHandler.listen = function(handle){
	BackHandler.addEventListener('hardwareBackPress', handle);
	return () => BackHandler.removeEventListener('hardwareBackPress', handle);
};
